export default __webpack_public_path__ + "static/media/uv-reference.dba5e4c6.png";